const URL = {
  SUGGEST_GOAL: 'outline/suggest-goal',
  SUGGEST_SECTION_TITLE: 'outline/suggest-section-title',
  SUGGEST_PAGE_TITLE: 'outline/suggest-page-title',
  SUGGEST_PAGE_OUTLINE: 'outline/suggest-page-outline',
}

export default URL
